/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Select_Exercise_PromptInputs */

const fr_leaderboard_select_exercise_prompt = /** @type {(inputs: Leaderboard_Select_Exercise_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un exercice pour voir le classement.`)
};

/**

* @param {Leaderboard_Select_Exercise_PromptInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_select_exercise_prompt = /** @type {((inputs?: Leaderboard_Select_Exercise_PromptInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Select_Exercise_PromptInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_select_exercise_prompt(inputs)
});